import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useNavigationGuard: <S, T extends ReadonlyArray<S>>(
  values: T | S,
  msg: string,
  check?: (val: typeof values) => boolean
) => ReturnType<typeof useEffect> = (
  values,
  msg,
  check = (val) =>
    Array.isArray(val) ? val.reduce((prev, curr) => prev && !curr, true) : !val
) => {
  const router = useRouter();
  const [confirmed, setConfirmed] = useState(false);
  return useEffect(
    () => {
      const handleWindowClose = (e: BeforeUnloadEvent) => {
        if (check(values)) {
          return;
        }
        e.preventDefault();
        return (e.returnValue = msg);
      };
      const handleBrowseAway = () => {
        if (confirmed || check(values) || window.confirm(msg)) {
          setConfirmed(true);
          return;
        }
        router.events.emit('routeChangeError');
        throw 'routeChange aborted.';
      };
      window.addEventListener('beforeunload', handleWindowClose);
      router.events.on('routeChangeStart', handleBrowseAway);
      return () => {
        window.removeEventListener('beforeunload', handleWindowClose);
        router.events.off('routeChangeStart', handleBrowseAway);
      };
    },
    Array.isArray(values) ? values : [values]
  );
};
